import script from "./editCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./editCompany.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__